import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateByMaterialsForm',
  setup(__props) {

const m = defineMessages({
  materials: '材料',
});

return { __sfc: true,m }
}

})